<template>
  <div class="flex flex-col gap-2 p-4">
    <template v-if="isElectron()">
      <Update />

      <Running />

      <News />
    </template>

    <ContactUs />

    <Copyright />

    <template v-if="isElectron()">
      <ErrorLog />
    </template>
  </div>
</template>

<script lang="ts" setup>
  import Update from './Update.vue'
  import Running from './Running.vue'
  import News from './News.vue'
  import ContactUs from './ContactUs.vue'
  import Copyright from './Copyright.vue'
  import ErrorLog from './ErrorLog.vue'
  import { isElectron } from '@/utils/env'
</script>

<style scoped></style>
